module.exports = __webpack_public_path__ + "img/filter.41232749.svg";